import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=4c8a2c0e&scoped=true&"
import script from "./Zones.vue?vue&type=script&lang=js&"
export * from "./Zones.vue?vue&type=script&lang=js&"
import style0 from "./Zones.vue?vue&type=style&index=0&id=4c8a2c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a2c0e",
  null
  
)

export default component.exports